"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DisplayForRole = require("./DisplayForRole");
Object.keys(_DisplayForRole).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DisplayForRole[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DisplayForRole[key];
    }
  });
});
var _Feature = require("./Feature");
Object.keys(_Feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Feature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Feature[key];
    }
  });
});
var _Version = require("./Version");
Object.keys(_Version).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Version[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Version[key];
    }
  });
});
var _GetForegroundColorForColor = require("./GetForegroundColorForColor");
Object.keys(_GetForegroundColorForColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetForegroundColorForColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetForegroundColorForColor[key];
    }
  });
});
var _GetRandomColor = require("./GetRandomColor");
Object.keys(_GetRandomColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GetRandomColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _GetRandomColor[key];
    }
  });
});
var _TimeFormats = require("./TimeFormats");
Object.keys(_TimeFormats).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TimeFormats[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TimeFormats[key];
    }
  });
});
var _TextHelpers = require("./TextHelpers");
Object.keys(_TextHelpers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextHelpers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextHelpers[key];
    }
  });
});
var _RoleHelper = require("./RoleHelper");
Object.keys(_RoleHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _RoleHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RoleHelper[key];
    }
  });
});
var _colors = require("./colors");
Object.keys(_colors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _colors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _colors[key];
    }
  });
});
var _IsMobile = require("./IsMobile");
Object.keys(_IsMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IsMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _IsMobile[key];
    }
  });
});
var _ScreenShare = require("./ScreenShare");
Object.keys(_ScreenShare).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScreenShare[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScreenShare[key];
    }
  });
});